import React, { createContext, useState, useEffect } from 'react';
import { Link, useNavigate } from "react-router-dom";
export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(() => {
    const savedUser = localStorage.getItem('user');
    return savedUser ? JSON.parse(savedUser) : null;
  });
  const navigate = useNavigate();
  const updateUserState = (newUser) => {
    setUser(newUser);
    if (newUser) {
      localStorage.setItem('user', JSON.stringify(newUser));
    } else {
      localStorage.removeItem('user');
    }
  };

  const login = (userData, token) => {
    // Nếu userData chưa có token nhưng tham số truyền vào có token, ta gán vào luôn
    const userToSave = {
      ...userData,
      accessToken: token || userData?.accessToken || userData?.token || localStorage.getItem("token")
    };

    setUser(userToSave);
    if (token) {
      localStorage.setItem("token", token);
    }
    localStorage.setItem('user', JSON.stringify(userToSave));
  };

  const logout = () => {
    setUser(null);
    localStorage.removeItem('user');
    localStorage.removeItem('token');
    navigate("/");
  };

  return (
    <AuthContext.Provider value={{ user, setUser: updateUserState, login, logout, isAdmin: user?.role === 'ADMIN' }}>
      {children}
    </AuthContext.Provider>
  );
};